<template>
  <div class="body">
    <!-- 顶部导航栏 -->
    <div class="nav_menu">
      <div class="menus">
        <!-- 学校logo -->
        <a class="logo" href="https://www.scujj.edu.cn/"><img :src="httpurl + '/Templets/image/logo.svg'" alt="" /></a>
        <!-- 导航项 -->
        <div class="menu">
          <div class="nav_4">
            <div class="ntitle"></div>
            <a href="https://www.scujj.edu.cn/html/page/xxjj.html" class="ntitle" target="_blank">学校简介</a>
            <div class="nline"></div>
          </div>
          <div class="nav_3">
            <div class="ntitle">教学科研</div>
            <div class="nline"></div>
            <!-- 悬停显示 -->
            <div class="hover_2">
              <div class="hover_2_wrapper">
                <div class="hover_title">教学科研</div>
                <div class="hover_2_lists">
                  <div class="list_1">
                    <div class="list_1_img">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_1_part"><a class="list_2_title active" href="https://jwc.scujj.edu.cn/"
                        target="_blank">教学管理</a>
                      <a class="list_2_title active" href="https://keyan.scujj.edu.cn/" target="_blank">科研管理</a>
                      <a class="list_2_title active" href="https://syjx.scujj.edu.cn/" target="_blank">实验教学</a>
                      <a class="list_2_title active" href="https://jsfzzx.scujj.edu.cn/" target="_blank">教师发展</a>
                    </div>
                  </div>
                  <div class="list_1">
                    <div class="list_1_img">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>

                    <div class="list_1_jpg">
                      <img src="/files/image/20220516/4407f217-5518-40fa-874f-72a8972e3531.jpg" alt="">
                    </div>
                    <div class="list_1_text">
                      <a href="https://jwc.scujj.edu.cn/">学生为本、通专并重<br>知行合一、教学相长</a>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav_1">
            <div class="ntitle">教学单位</div>
            <div class="nline"></div>
            <!-- 悬停显示 -->
            <div class="hover_1">
              <div class="hover_1_wrapper">
                <div class="hover_title">教学单位</div>
                <div class="hover_lists">
                  <div class="list">
                    <div class="listimg">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_parts">
                      <a href="https://szjj.scujj.edu.cn/" class="list_part active" target="_blank">数字经济学院</a>
                      <a href="https://wxycm.scujj.edu.cn/" class="list_part active" target="_blank">文学与传媒学院</a>
                      <a href="https://wgy.scujj.edu.cn/" class="list_part active" target="_blank">外国语学院</a>
                      <a href="https://jx.scujj.edu.cn/" class="list_part active" target="_blank">机械工程学院</a>
                    </div>
                  </div>
                  <div class="list">
                    <div class="listimg">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_parts">
                      <a href="https://dqydzxxgc.scujj.edu.cn/" class="list_part active" target="_blank">电气与电子学院</a>
                      <a href="https://jsj.scujj.edu.cn/home/index.html" class="list_part active"
                        target="_blank">计算机学院</a>
                      <a href="https://tmgc.scujj.edu.cn/" class="list_part active" target="_blank">土木工程学院</a>
                      <a href="https://bj.scujj.edu.cn/" class="list_part active" target="_blank">白酒学院</a>
                    </div>
                  </div>
                  <div class="list">
                    <div class="listimg">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_parts">
                      <a href="https://sxy.scujj.edu.cn/" class="list_part active" target="_blank">商学院</a>
                      <a href="https://ysxy.scujj.edu.cn/" class="list_part active" target="_blank">艺术学院</a>
                      <a href="https://tyjxb.scujj.edu.cn/" class="list_part active" target="_blank">体育学院</a>
                      <a href="https://dpxy.scujj.edu.cn/" class="list_part active" target="_blank">东坡学院</a>
                    </div>
                  </div>
                  <div class="list">
                    <div class="listimg">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_parts">
                      <a href="https://mtys.scujj.edu.cn/" class="list_part active" target="_blank">媒体艺术学院</a>
                      <a href="https://xfxy.scujj.edu.cn/" class="list_part active" target="_blank">科大讯飞学院</a>
                      <a href="https://tf.scujj.edu.cn/" class="list_part active" target="_blank">天府智能制造产业学院</a>
                      <a href="https://sz.scujj.edu.cn/" class="list_part active" target="_blank">马克思主义学院</a>
                    </div>
                  </div>
                  <div class="list">
                    <div class="listimg">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_parts">
                      <a href="https://ts.scujj.edu.cn/" class="list_part active" target="_blank">通识教学部</a>
                      <a href="https://sx.scujj.edu.cn/home/index.html" class="list_part active" target="_blank">数学教学部</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav_2">
            <!-- <div class="nbg"></div> -->
            <div class="ntitle">招生就业</div>
            <div class="nline"></div>
            <!-- 悬停显示 -->
            <div class="hover_2">
              <div class="hover_2_wrapper">
                <div class="hover_title">招生就业</div>
                <div class="hover_2_lists">
                  <div class="list_1">
                    <div class="list_1_img">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_1_part"><a class="list_1_title active" href="https://zs.scujj.edu.cn/"
                        target="_blank">招生</a>
                      <a class="list_1_title active" href="https://jy.scujj.edu.cn/" target="_blank">就业</a>
                    </div>
                  </div>
                  <div class="list_1">
                    <div class="list_1_img">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>

                    <div class="list_1_jpg">
                      <img src="/files/image/20221028/e3d8e2fd-17c8-444c-855c-1b57a98dd982.jpg" alt="学校全面推进2023届毕业生就业工作">
                    </div>
                    <div class="list_1_text">
                      <a href="https://www.scujj.edu.cn/html/news/xw/zhxw/2023/2023-03/22737.html"
                        target="_blank">学校全面推进2023届毕业生就业工作</a>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav_3 nav_5">
            <div class="ntitle">学生发展</div>
            <div class="nline"></div>
            <!-- 悬停显示 -->
            <div class="hover_2">
              <div class="hover_2_wrapper">
                <div class="hover_title">学生发展</div>
                <div class="hover_2_lists">
                  <div class="list_1">
                    <div class="list_1_img">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>
                    <div class="list_1_part"><a class="list_2_title active" href="https://tw.scujj.edu.cn/"
                        target="_blank">锦江青年</a>
                      <a class="list_2_title active" href="https://xl.scujj.edu.cn/" target="_blank">心理健康</a>
                      <a class="list_2_title active" href="https://stu.scujj.edu.cn/" target="_blank">学工在线</a>
                    </div>
                  </div>
                  <div class="list_1">
                    <div class="list_1_img">
                      <img src="/Templets/image/nav/line.png" alt="">
                    </div>

                    <div class="list_1_jpg">
                      <img src="/files/image/20230314/47c0699b-710f-4b6b-af89-04c207721a0f.jpg"
                        alt="我校在省高校学生资助诚信教育活动中斩获佳绩">
                    </div>
                    <div class="list_1_text">
                      <a href="https://stu.scujj.edu.cn/xuegong/xuegongdetail.html?newsId=578"
                        target="_blank">我校在省高校学生资助诚信教育活动中斩获佳绩</a>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 其他 -->
        <div class="others">
          <!-- 搜索框 -->
          <div class="search">
            <!-- 站内搜索代码开始 -->
            <input type="search" id="tags" placeholder="搜索全站" />
            <div class="search_icon pointer">
              <img id="searchBtn" :src="httpurl + '/Templets/image/search.svg'" alt="" />
            </div>
            <!-- 站内搜索代码结束 -->
          </div>
          <!-- 登录 -->
          <!-- <div id="dlu" class="login-btn login pointer"><span>登&nbsp;录</span></div>
          <div id="grzx" class="login-btn login pointer grzxnone"><span></span></div> -->
          <!-- EN -->
          <div class="font">
            <span><a href="https://portal.scujj.edu.cn/onlineServiceClient/#/" target="_blank">网上服务大厅</a></span>
            <span><a href="https://en.scujj.edu.cn" target="_blank">EN</a></span>
          </div>
        </div>
        <!-- 手机搜索框 -->
        <div id="nav_search_form">
          <input id="nav_search_input" type="input" />
          <input onclick="NavSearch()" id="nav_search_btn" type="submit" />
        </div>
        <div class="function-wrap">
          <!-- 手机搜索按钮 -->
          <img id="nav_search" :src="httpurl + '/Templets/image/top_search.png'" alt="" />
          <!-- 手机菜单 -->
          <div class="sp_nav">
            <img :src="httpurl + '/Templets/image/nav_menu.png'" alt="" />
          </div>
        </div>
        <div class="sjj_nav">
          <ul>
            <li>
              <a href="https://www.scujj.edu.cn">首页</a>
            </li>
            <li><a href="https://www.scujj.edu.cn/html/page/xxjj.html" target="_blank">学校简介</a></li>
            <li>
              <a href="javascript:void(0);">教学科研</a><i class="sp_nav_xjb"><svg t="1496193951932" class="icon" style=""
                  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="995"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
                  <path
                    d="M768.468 428.876l-84.723-84.723-170.711 170.711-170.711-170.711-84.723 84.723 170.711 170.711-0.092 0.091 84.723 84.724 0.092-0.092 0.092 0.092 84.723-84.724-0.092-0.091z"
                    p-id="996"></path>
                </svg></i>
              <ul>
                <li><a href="https://jwc.scujj.edu.cn">教学管理</a></li>
                <li><a href="https://keyan.scujj.edu.cn">科研管理</a></li>
                <li><a href="https://syjx.scujj.edu.cn">实验教学</a></li>
                <li><a href="http://jsfzzx.scujj.edu.cn/">教师发展</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0);">教学单位</a><i class="sp_nav_xjb"><svg t="1496193951932" class="icon" style=""
                  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="995"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
                  <path
                    d="M768.468 428.876l-84.723-84.723-170.711 170.711-170.711-170.711-84.723 84.723 170.711 170.711-0.092 0.091 84.723 84.724 0.092-0.092 0.092 0.092 84.723-84.724-0.092-0.091z"
                    p-id="996"></path>
                </svg></i>
              <ul>
                <li><a href="https://szjj.scujj.edu.cn/">数字经济学院</a></li>
                <li><a href="https://wxycm.scujj.edu.cn/">文学与传媒学院</a></li>
                <li><a href="https://wgy.scujj.edu.cn/">外国语学院</a></li>
                <li><a href="https://jx.scujj.edu.cn/">机械工程学院</a></li>
                <li><a href="https://dqydzxxgc.scujj.edu.cn/">电气与电子信息工程学院</a></li>
                <li><a href="https://jsj.scujj.edu.cn/home/index.html">计算机学院</a></li>
                <li><a href="https://tmgc.scujj.edu.cn/">土木工程学院</a></li>
                <li><a href="https://bj.scujj.edu.cn/">白酒学院</a></li>
                <li><a href="https://sxy.scujj.edu.cn/">商学院</a></li>
                <li><a href="https://ysxy.scujj.edu.cn/">艺术学院</a></li>
                <li><a href="https://tyjxb.scujj.edu.cn/">体育学院</a></li>
                <li><a href="https://dpxy.scujj.edu.cn/">东坡学院</a></li>
                <li><a href="https://mtys.scujj.edu.cn/">媒体艺术学院</a></li>
                <li><a href="https://xfxy.scujj.edu.cn/">科大讯飞学院</a></li>
                <li><a href="https://tf.scujj.edu.cn/" >天府智能制造产业学院</a></li>
                <li><a href="https://sz.scujj.edu.cn/">马克思主义学院</a></li>
                <li><a href="https://ts.scujj.edu.cn/">通识教学部</a></li>
                <li><a href="https://sx.scujj.edu.cn/home/index.html">数学教学部</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0);">招生就业</a><i class="sp_nav_xjb"><svg t="1496193951932" class="icon" style=""
                  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="995"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
                  <path
                    d="M768.468 428.876l-84.723-84.723-170.711 170.711-170.711-170.711-84.723 84.723 170.711 170.711-0.092 0.091 84.723 84.724 0.092-0.092 0.092 0.092 84.723-84.724-0.092-0.091z"
                    p-id="996"></path>
                </svg></i>
              <ul>
                <li><a href="https://zs.scujj.edu.cn/">招生</a></li>
                <li><a href="https://jy.scujj.edu.cn/">就业</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0);">学生发展</a><i class="sp_nav_xjb"><svg t="1496193951932" class="icon" style=""
                  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="995"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
                  <path
                    d="M768.468 428.876l-84.723-84.723-170.711 170.711-170.711-170.711-84.723 84.723 170.711 170.711-0.092 0.091 84.723 84.724 0.092-0.092 0.092 0.092 84.723-84.724-0.092-0.091z"
                    p-id="996"></path>
                </svg></i>
              <ul>
                <li><a href="https://tw.scujj.edu.cn/">锦江青年</a></li>
                <li><a href="https://xl.scujj.edu.cn/">心理健康</a></li>
                <li><a href="https://stu.scujj.edu.cn/">学工在线</a></li>
              </ul>
            </li>
            <li><a href="https://en.scujj.edu.cn/">EN</a></li>

          </ul>
        </div>
        <!-- 登陆框 -->
        <div class="login-wrapper">
          <div class="bg">
            <p>登录您的ID</p>
            <p>Login</p>
          </div>
          <div class="login-form">
            <form action="">
              <div class="label-item">
                <span class="label">用户名:</span>
                <input id="userName" type="text" />
              </div>
              <div class="label-item">
                <span class="label">密码:</span>
                <input id="userPassword" type="password" />
              </div>
              <div class="label-item" style="display: flex;justify-content: space-between;">
                <span class="label" style="margin-top:10px ">验证码:</span>
                <input id="verificationCode" class="code-input" type="text" />
                <div class="canvasbox">
                  <canvas class="codeCanvas" id="s-canvas" width="100" height="37"></canvas>
                </div>
              </div>
              <div class="btn-wrapper">
                <button id="clickLogin">登录</button>
                <button id="clickReset">重置</button>
              </div>
            </form>
          </div>
        </div>
        <!-- 登录后显示 -->
        <div class="informationBigbox grzxnone">
          <div class="information-left">
            <img src="" alt="">
          </div>
          <div class="information-right">
            <p id="identiName"></p>
            <p id="identiAge"></p>
            <p id="identiId"></p>
            <p id="identity"></p>
            <p id="identityType"></p>
            <p id="schoolType"></p>
            <div id="anniu" pointe>
              退出
            </div>
          </div>
        </div>
        <!-- 结束 -->
      </div>
    </div>
    <!-- 轮播图 -->
  </div>
</template>
<script src="https://jjxymss.scujj.edu.cn/Templets/js/jquery.min.js?v1.11.0"></script>
<script>
let httpurl = 'https://jjxymss.scujj.edu.cn' //正式部署的url

$(document).ready(function () {
  $('#nav_search').on('click', function () {
    $('#nav_search_input').val('')
    if ($('#nav_search_form').css('display') !== 'block') {
      $('#nav_search_form').show()
      $('#mask').show()
      $('body').css('overflow', 'hidden')
    } else {
      $('#nav_search_form').hide()
      $('#mask').hide()
      $('body').css('overflow', 'auto')
    }
  })
  $('#nav_search_btn').on('click', function () {
    if (
      $('#nav_search_input').val().length >= 2 &&
      $('#nav_search_input').val().length <= 200
    ) {
      window.location.href =
        'https://www.scujj.edu.cn/search.html?type=news&tags=' +
        encodeURIComponent($('#nav_search_input').val()) +
        ''
    }
  })
  $('#nav_search_input').keypress(function (e) {
    if (e.keyCode === 13) {
      if (
        $('#nav_search_input').val().length >= 2 &&
        $('#nav_search_input').val().length <= 200
      ) {
        window.location.href =
          'https://www.scujj.edu.cn/search.html?type=news&tags=' +
          encodeURIComponent($('#nav_search_input').val()) +
          ''
      }
    }
  })
  $('#searchBtn').on('click', function () {
    if ($('#tags').val().length >= 2 && $('#tags').val().length <= 200) {
      window.location.href =
        'https://www.scujj.edu.cn/search.html?type=news&tags=' +
        encodeURIComponent($('#tags').val()) +
        ''
    } else {
      alert('搜索最小长度2字符，最大长度200字符。')
    }
  })
  // $('.login-btn').on('click', function () {
  //   if ($('div').hasClass('active')) {
  //     $('div').removeClass('active')
  //   } else {
  //     $('.login-wrapper').addClass('active')
  //   }
  // })
})
if (window.document.clientWidth <= 640) {
  $('.newlist_1').each(function (index, v) {
    if (index > 3) {
      v.style.display = 'none'
    }
  })
} else {
  $('.newlist_1').each(function (index, v) {
    if (index > 5) {
      v.style.display = 'none'
    }
  })
}
$(()=>{
    let off = false
    let dlus = false
    let identifyCodes= '1234567890'
    var identifyCode= ''
    // ----
    $('#grzx').hide()
    $('#grzx').removeClass('grzxnone')
    $('.informationBigbox').removeClass('grzxnone')
    $('.informationBigbox').hide()
    $('#anniu').on('click', () => {
        $('.informationBigbox').hide()
        $('#grzx').hide()
        $('#dlu').show()
        // sessionStorage.removeItem('userData');
        // sessionStorage.removeItem('userImg');
        localStorage.removeItem('userData');
        localStorage.removeItem('userImg');
    })
    $('#dlu').on('click', () =>{
       $('#userName').val('')
        $('#userPassword').val('')
        $('#verificationCode').val('')
        $('.login-wrapper').addClass('active')
       $('.login-wrapper').show()
       if (dlus) {
         $('.login-wrapper').hide()
         dlus = false
         return
       } else {
         $('.login-wrapper').show()
         dlus =true
       }
    })
    $('#grzx').on('click', ()=>{
        if (off === false) {
            $('.informationBigbox').show()
            off = true
            return
        }
        if (off === true) {
            $('.informationBigbox').hide()
            off = false
            return
        }
    })
    $('#clickLogin').on('click', () => {
      if($('#verificationCode').val() != identifyCode){
        alert('验证码不正确！')
        return
      }
        if ($('#userName').val() !== '' && $('#userPassword').val() !== '') {
        $.ajax({
            type: 'GET',
            url:httpurl+"/message/login",
            dataType: "json",
            data: {param:'login',lu:$('#userName').val(),lp:$('#userPassword').val()},
            success: (data)=> {
                let datas = JSON.parse(data.msg)
                if (datas.Result == 'error') {
                  alert('请输入正确的账号密码')
                  return
                }
                console.log(httpurl, 'kk')
                // sessionStorage.setItem('userData', data.msg)
                localStorage.setItem('userData', data.msg)
                $('#identiName').html('姓名：' +`${datas.Xm}`)
                $('#identiAge').html('性别：' +`${datas.Xb}`)
                $('#identiId').html('学（工）号：' +`${datas.Xh}`)
                $('#identity').html('身份：' +`${datas.Sfdl}`)
                $('#identityType').html('身份类别：' +`${datas.Sfxl}`)
                $('#schoolType').html('学院（部门）：' +`${datas.Bm}`)
                $('.informationBigbox').show()
                $('#dlu').hide()
                $('#grzx').html(datas.Xm)
                $('#grzx').show()
                $('.login-wrapper').hide()
                dlus = false
                off = true
            },
            error: (err) => {
                console.log(err)
            }
        })
        $.ajax({
            type: 'GET',
            url:httpurl+"/message/getPhoto",
            dataType: "json",
            data: {param:'login',lu:$('#userName').val(),lp:$('#userPassword').val()},
            success: (data)=> {
                // sessionStorage.setItem('userImg', data.msg)
                localStorage.setItem('userImg', data.msg)
                $('.information-left img').attr('src',data.msg)
            },
            error: (err) => {
                console.log(err)
            }
        })
        }
    })
    $('#clickReset').on('click', () => {
        $('#userName').val('')
        $('#userPassword').val('')
        $('#verificationCode').val('')
    })
     if (localStorage.getItem('userData')) {
        // var datass = sessionStorage.getItem('userData')
        // var dataImg = sessionStorage.getItem('userImg')
        var datass = localStorage.getItem('userData')
        var dataImg = localStorage.getItem('userImg')
        console.log(dataImg, 'sss')
        datass = JSON.parse(datass)
        $('#identiName').html('姓名：' +`${datass.Xm}`)
        $('#identiAge').html('性别：' +`${datass.Xb}`)
        $('#identiId').html('学（工）号：' +`${datass.Xh}`)
        $('#identity').html('姓名：' +`${datass.Sfdl}`)
        $('#identityType').html('身份：' +`${datass.Sfxl}`)
        $('#schoolType').html('学校（部门）：' +`${datass.Bm}`)
        // $('.informationBigbox').show()
        $('#dlu').hide()
        $('#grzx').html(datass.Xm)
        $('#grzx').show()
        $('.login-wrapper').hide()
         $('.information-left img').attr('src',dataImg)
        off = false
    }
    // // 设置 cookies
    // function setCookie(name,value) {
    // var Days = 30
    // var exp = new Date()
    // exp.setTime(exp.getTime() + Days*24*60*60*1000)
    // document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()
    // }
    // //读取 cookies
    // function getCookie(name){
    // var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
    // if(arr=document.cookie.match(reg))
    //     return unescape(arr[2])
    // else
    //     return null
    // }

    // 绘制验证码
    function randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    }
    // 四个数
    function makeCode (l) {
      for (let i = 0; i < l; i++) {
        identifyCode += identifyCodes[randomNum(0, identifyCodes.length)]
      }
    }
    // 生成一个随机的颜色
    function randomColor (min, max) {
      let r = randomNum(min, max)
      let g = randomNum(min, max)
      let b = randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    }
    function drawPic () {
      identifyCode = ''
      makeCode(4)
      let canvas = document.getElementById('s-canvas')
      let ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = randomColor(
        255,
        255
      )
      ctx.fillRect(0, 0, 100, 37)
      // 绘制文字
      for (let i = 0; i < identifyCode.length; i++) {
        drawText(ctx, identifyCode[i], i)
      }
      drawLine(ctx)
      drawDot(ctx)
    }
    function drawText (ctx, txt, i) {
      ctx.fillStyle = randomColor(0, 200)
      ctx.font =
      randomNum(30, 40) + 'px SimHei'
      let x = (i + 1) * (100 / (identifyCode.length + 1))
      let y = randomNum(40, 40)
      var deg = randomNum(-40, 40)
      // 修改坐标原点和旋转角度
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg * Math.PI) / 180)
      ctx.translate(-x, -y)
    }
    function drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = randomColor(
          100,
          255
        )
        ctx.beginPath()
        ctx.moveTo(
          randomNum(0, 100),
          randomNum(0, 37)
        )
        ctx.lineTo(
          randomNum(0, 100),
          randomNum(0, 37)
        )
        ctx.stroke()
      }
    }
    function drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 40; i++) {
        ctx.fillStyle = randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(
          randomNum(0, 100),
          randomNum(0, 45),
          1,
          0,
          2 * Math.PI
        )
        ctx.fill()
      }
    }
    drawPic()
    $('#s-canvas').on('click', drawPic)
})

</script>
<style lang="scss">
.login-wrapper .bg {
  width: 500px;
  height: 100%;
  background-size: cover;
  background-position: center right;
}
</style>
<style lang='scss'  scoped>
.grzxnone {
  display: none !important;
}
.font {
    display: inline-block;
    margin-left: 0;
    color: whitesmoke;
    font-size: 14px !important;
}
.font span{
    display: inline-block;
    margin-left: 15px;
}
.informationBigbox {
  position: fixed;
  top: 59px;
  right: 100px;
  width: 500px;
  height: auto;
  background: white;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  transition: all 1s ease-in;

  .information-left {
    width: 40%;

    img {
      width: 100%;
    }
  }

  .information-right {
    width: 50%;

    p {
      text-align: left;
      font-size: 16px;
    }

    #anniu {
      width: 70px;
      height: auto;
      background: #683699;
      font-size: 18px;
      font-weight: bold;
      color: white;
      text-align: center;
      margin: 0 auto;
      padding: 5px;
      box-sizing: border-box;
      border-radius: 10px;
      box-shadow: 2px 7px 7px -3px gray;
    }

    #anniu:hover {
      cursor: pointer;
    }
  }
}

.canvasbox {
  overflow: hidden;
  border-radius: 10px;

  canvas {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 640px) {

  //   .body .nav_menu {
  //     min-width: 340px;
  //     background-color: #5b0085;
  //     background: transparent;
  //   }
  .function-wrap {
    margin-top: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1366px) {
  .nav_menu {
    .menus {
      .logo {
        img {
          width: 200px;
        }
      }

      .others {
        margin-left: 20px;

        .login {
          margin-left: 10px;
        }
      }
    }
  }

}

@media screen and (max-width:768px) {
  .sjj_nav ul li a {
    width: 100%;
    display: inline-block;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .nav_menu {
    .menus {
      .logo {
        img {
          width: 110px;
        }
      }

      .others {
        margin-left: 0px;

        .login {
          margin-left: 20px;
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .login-wrapper {
    width: 512px;
    left: 10%;

    .bg {
      width: 45%;
    }

    .bg p:nth-child(1) {
      font-size: .7rem;
    }

    .login-form {
      width: 55%;
      padding: 10px;

      .label-item {
        width: 100%;
      }

      .label {
        font-size: 12px;
        width: 50px;
      }

      input {
        width: 64%;
        font-size: 12px;
      }

      .btn-wrapper {
        margin-left: 0;
      }
    }
  }

  .active {
    height: 300px;
  }
}

@media (width: 1024px) {
  .login-wrapper {
    width: 512px;
    right: 10%;

    .bg {
      width: 45%;
    }

    .bg p:nth-child(1) {
      font-size: .7rem;
    }

    .login-form {
      width: 55%;
      padding: 10px;

      .label-item {
        width: 100%;
      }

      .label {
        font-size: 12px;
        width: 50px;
      }

      input {
        width: 64%;
        font-size: 12px;
      }

      .btn-wrapper {
        margin-left: 0;
      }
    }
  }

  .active {
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue